export const theme = Object.freeze({
  // apply ant design theme
})
